// extracted by mini-css-extract-plugin
export default {"children_container":"SubMenuAndMainContainer_children_container__nE3qt"};